import { getAuthUser } from "../utils/authUser.js"
import { clearAuthUser, getSessionId, setSessionId } from "../utils/auth-storage.js"
import { hostAppCall } from "../utils/appFunctions.js"
import { createFormData } from "../utils/formdata.js"
import { isDebug } from "../utils/debug.js"
import { fetchPostJsonIfValid } from "../utils/fetch-json.js"
import { el, mount } from "redom";
import type { User } from "#/types"
// FACEBOOK =========================================================

// https://developers.facebook.com/docs/javascript/quickstart
// https://developers.facebook.com/docs/facebook-login/web
// Before updating API version, check this upgrade tool: https://developers.facebook.com/tools/api_versioning/334888110003366/
window.fbAsyncInit = () => {
    FB.init({
        appId: '334888110003366',
        autoLogAppEvents: true,
        xfbml: true,
        version: 'v26.0'
    });
};

(function (d, s, id) {
    let js, fjs = d.getElementsByTagName(s)[0];
    if (d.getElementById(id)) { return; }
    js = d.createElement(s); js.id = id;
    js.src = "https://connect.facebook.net/en_US/sdk.js";
    fjs.parentNode?.insertBefore(js, fjs);
}(document, 'script', 'facebook-jssdk'));

const fbLogin = (): void => {
    FB.login(function (response) {
        if (response.authResponse) {
            const tokenStr = response.authResponse.accessToken;
            FB.api(
                '/me',
                { fields: ['name', 'email'] },
                resp => loginOnServer("facebook", resp.name, resp.email, tokenStr)
            )
        }
    },
        { scope: 'email' }
    );
}
const loadedPromise = new Promise((resolve) => {
    window.addEventListener("load", resolve)
})

// GOOGLE  SIGNIN ===================================================
// https://developers.google.com/identity/gsi/web/reference/js-reference
const googleSigninInit = async (element: HTMLDivElement): Promise<void> => {
    await loadedPromise
    const parseJwt = (token: string) => {
        const base64Url = token.split('.')[1]
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
        const jsonPayload = decodeURIComponent(window.atob(base64).split('').map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)).join(''))
        return JSON.parse(jsonPayload)
    }

    google.accounts.id.initialize({
        client_id: "654923952681-unqpcb8c6q65piohv1aacf5vf6ak44is.apps.googleusercontent.com",
        callback: (response) => {
            const user = parseJwt(response.credential)
            loginOnServer("googlesigninweb", user.name, user.email, response.credential)
        }
    })
    // https://developers.google.com/identity/gsi/web/reference/js-reference#GsiButtonConfiguration
    google.accounts.id.renderButton(element, {
        type: "standard",
        text: "signin_with",
        theme: "filled_blue",
        size: "large",
        shape: "square",
        logo_alignment: "center",
        width: 400,
        locale: "en-US"
    })
}


// WECHAT  SIGNIN ===================================================
const wechatLogin = () => {
    const appid = "wxa4402cb694dfdd60";
    const redirect_uri = "https%3A%2F%2Fsoundcorset.com%2Fdynamic%2Fwechatlogin"; // the url address must be urlencoded.
    const wechat_url = "https://open.weixin.qq.com/connect/qrconnect?appid=" + appid + "&redirect_uri=" + redirect_uri + "&response_type=code&scope=snsapi_login&state=wechat_web_login";
    // Note: In the case of testing with development server, use the below url. If using that url, soundcorset users cannot login with wechat.
    // And development information of website application in WeChat open platform website (https://open.weixin.qq.com/) must be changed to development server domain temporarily.
    // And pathPrefix("wechatlogin")'s url needs to be changed in the same way, too.
    //    const wechat_url = "https://open.weixin.qq.com/connect/qrconnect?appid=" + appid + "&redirect_uri=https%3A%2F%2Fnearylocal.soundcorset.com%2Fdynamic%2Fwechatlogin&response_type=code&scope=snsapi_login&state=wechat_web_login";
    clearAuthUser()
    window.open(wechat_url, "_self");
}

const bypassAuthLogin = (): Promise<void> => loginOnServer("bypassAuth", "Mock user for test", "soundcorset@gmail.com", "fakeToken")

// LOGIN MODAL =================================================== // use this with loginmodal.css
let loginModal: HTMLDivElement | null = null

export const mountLoginModal = (): HTMLDivElement => {
    if (loginModal?.isConnected) return loginModal

    const facebookSignInButton = el(".btn btn-social btn-facebook socialCenter", { onclick: fbLogin }, el("i.fab fa-facebook-f"), "Sign in with facebook");
    // Note: It is impossible to open a google-sign-in modal using onclick() because it is created by the Google-provided function google.accounts.id.renderButton(). That's why this transparent button is added.
    const transparentGoogleSignInButton = el("div", { style: "opacity: 0; position: fixed; transform: translate(-15%, -80%);" })
    const googleSignInButton = el(".btn btn-social btn-google socialCenter", { style: "padding-left: 44px;" }, el("i.fab fa-google"), "Sign in with Google", transparentGoogleSignInButton)
    const wechatSignInButton = el(".btn btn-social btn-weixin socialCenter", { onclick: wechatLogin }, el("i.fab fa-weixin", { style: "color:white" }), "Sign in with WeChat")
    const signInButtons = [facebookSignInButton, googleSignInButton, wechatSignInButton]
    if (isDebug.mode()) {
        signInButtons.unshift(el(".btn btn-social btn-secondary socialCenter", { onclick: bypassAuthLogin }, "Bypass authentication (dev only)"))
    }

    loginModal = el(".modal fade#loginModal", { tabindex: "-1", role: "dialog", "aria-labelledby": "loginModal", "aria-hidden": "true" },
        el(".modal-dialog modal-dialog-centered",
            el(".modal-content", //{ style: "background: #eeeeee;"},
                el(".modal-header", el("h6.subHead", "SIGN IN")),
                el("form.noMargin", { method: "POST" },
                    el(".modal-body d-grid gap-2", { style: "padding: 0.5rem 1rem 1.5rem 1rem;" },
                        ...signInButtons
                    )
                )
            )
        )
    )
    mount(document.body, loginModal)
    googleSigninInit(transparentGoogleSignInButton);
    return loginModal
}

// SERVER **************************************************************/
/***********************************************************************/
/***********************************************************************/
const loginOnServer = async (typeLg: string, nameUser?: string, idNum?: string, tokenStr?: string): Promise<void> => {
    const spinner = el(".loader")
    loginModal?.appendChild(spinner)
    const link = "/v1/accounts"
    const body = createFormData({ type: typeLg, name: nameUser, token: tokenStr, id: idNum })
    try {
        const user = await fetchPostJsonIfValid(link, body) as User
        if (user) {
            console.log("done login" + user.sessionId)
            setSessionId(user.sessionId)
        }
        return getAuthUser().then(_ => reloadThePage())
    } finally {
        spinner.remove()
        return
    }
}

export const logoutOnServer = (redirectTo?: string) => {
    const formData = createFormData({ sessionId: getSessionId()});
    return fetchPostJsonIfValid("/v1/me/logout", formData).then(r => {
        clearAuthUser()
        if (redirectTo) window.location.href = redirectTo
        else reloadThePage()
        hostAppCall("logout")
        return r
    })
}

// Android WebView often ignores location.reload(). 
// Switched to assigning location.href with origin, pathname, and search to force a full reload reliably.
export function reloadThePage() {
    location.href = location.origin + location.pathname + location.search;
}